import LegalLayout from "@/pages/legal/LegalLayout";

export default function DoNotSellPage() {
  return (
    <LegalLayout
      title="Do Not Sell or Share My Personal Information"
      eyebrow="California Notice"
      lastUpdated="February 1, 2026"
      testid="dnsmpi-page"
    >
      <p>
        Under the California Consumer Privacy Act (CCPA), as amended by the California Privacy Rights Act
        (CPRA), California residents have the right to opt out of the "sale" or "sharing" of their personal
        information.
      </p>

      <h2>Our Practice</h2>
      <p>
        <strong>
          Ministry Branch does not sell personal information for monetary value, and does not "share"
          personal information for cross-context behavioral advertising as those terms are defined under
          the CPRA.
        </strong>{" "}
        Accordingly, there is nothing for California residents to opt out of with respect to the ChurchFlow
        service at this time.
      </p>

      <h2>If Our Practices Change</h2>
      <p>
        If we ever begin selling or sharing personal information as defined under the CPRA, we will (a) update
        this notice, (b) update our <a href="/legal/privacy">Privacy Policy</a> and{" "}
        <a href="/legal/ccpa">CCPA/CPRA Rights</a> notice, and (c) provide a prominent "Do Not Sell or Share My
        Personal Information" opt-out mechanism on this page and in the global navigation.
      </p>

      <h2>Submit a Request Anyway</h2>
      <p>
        Even though there is currently no sale or sharing of personal information to opt out of, you may still
        submit a request to confirm our practices by emailing{" "}
        <a href="mailto:privacy@ministrybranch.com">privacy@ministrybranch.com</a> with the subject "Do Not
        Sell / Share Request." We will respond within 15 business days as required by the CPRA.
      </p>

      <h2>Global Privacy Control (GPC)</h2>
      <p>
        We respect Global Privacy Control signals where applicable. If your browser transmits a GPC signal, we
        will treat it as a request to opt out of any sale or sharing of personal information for that browser.
      </p>

      <h2>Contact</h2>
      <p>
        Ministry Branch · Fresno, California · USA<br />
        <a href="mailto:privacy@ministrybranch.com">privacy@ministrybranch.com</a>
      </p>
    </LegalLayout>
  );
}
